<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="white-card">
        <div class="header-title-row">
          <div class="header-left">
            <img
              src="assets/svg/money-icon.svg"
              alt="Historial de etapas"
              class="center-svg"
            />
            <h1 class="text-semibold color-org t-24">
              Partidas de presupuestos
            </h1>
            <button class="btn btn-primary-outline" (click)="volverAlPresupuesto()">
              Volver al presupuesto
            </button>
            
          </div>
          <div class="header-actions">
            <button class="action-btn outline">Clasificar</button>
            <button class="action-btn outline" (click)="openUpdateItems()">Modificar productos</button>
            <button class="action-btn primary" (click)="openAddProductModal()">
              Agregar productos
            </button>
          </div>
        </div>
        <div class="header-stats mt-3">
          <span
            >{{items.length}} elementos | Se actualizó hace 2 minutos | Ordenado por última
            modificación</span
          >
        </div>
        <div class="content-area mt-5">
          <div class="prospectos-table mh-50">
            <table>
              <thead>
                <tr>
                  <th class="checkbox-column text-center"></th>
                  <th>
                    <div class="d-flex align-items-center">
                      Producto
                      <img
                        src="assets/svg/arrow-down-black.svg"
                        width="14"
                        class="ms-1"
                      />
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">
                      Precio de venta
                      <img
                        src="assets/svg/arrow-down-black.svg"
                        width="14"
                        class="ms-1"
                      />
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">
                      Cantidad
                      <img
                        src="assets/svg/arrow-down-black.svg"
                        width="14"
                        class="ms-1"
                      />
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">
                      Subtotal
                      <img
                        src="assets/svg/arrow-down-black.svg"
                        width="14"
                        class="ms-1"
                      />
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">
                      Descuento (%)
                      <img
                        src="assets/svg/arrow-down-black.svg"
                        width="14"
                        class="ms-1"
                      />
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">
                      Precio total
                      <img
                        src="assets/svg/arrow-down-black.svg"
                        width="14"
                        class="ms-1"
                      />
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">
                      Precio de lista
                      <img
                        src="assets/svg/arrow-down-black.svg"
                        width="14"
                        class="ms-1"
                      />
                    </div>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of items; let i = index">
                  <td class="checkbox-column">
                    <h4>{{ i + 1 }}.</h4>
                  </td>
                  <td>{{ item.producto_servicio || 'Sin nombre' }}</td>
                  <td>CLP {{ item.precio_unitario || 0 | number:'1.0-0' }}</td>
                  <td>{{ item.cantidad || 1 }}</td>
                  <td>
                    CLP {{ (item.cantidad * item.precio_unitario) || 0 |
                    number:'1.0-0' }}
                  </td>
                  <td></td>
                  <td>
                    CLP {{ (item.cantidad * item.precio_unitario) || 0 |
                    number:'1.0-0' }}
                  </td>
                  <td>0</td>
                  <td class="actions-cell">
                    <div
                      class="dropdown-container"
                      (click)="$event.stopPropagation()"
                    >
                      <button
                        class="dots-button"
                        (click)="toggleActionsMenu('menu-' + item.presupuesto_item_id)"
                      >
                        <svg class="dots-icon" viewBox="0 0 24 24">
                          <circle cx="12" cy="5" r="2" />
                          <circle cx="12" cy="12" r="2" />
                          <circle cx="12" cy="19" r="2" />
                        </svg>
                      </button>
                      <div
                        class="dropdown-menu"
                        [class.show]="openedMenuId === 'menu-' + item.presupuesto_item_id"
                      >
                        <button class="dropdown-item">Modificar</button>
                        <button
                          class="dropdown-item"
                          (click)="deleteItem(item)"
                        >
                          Eliminar
                        </button>
                        <button class="dropdown-item">
                          Cambiar propietario
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
